import { createSlice } from "@reduxjs/toolkit";
import { fetchNsfData, fetchNsfHistory } from "./api";

const initialState = {
  nsfData: {
    data: null,
    status: "idle",
  },
  nsfHistory: {
    data: null,
    status: "idle",
  },
};

export const nsfSlice = createSlice({
  name: "nsf",
  initialState,
  reducers: {
    setNsfStatus: (state, action) => {
      state.nsfData.status = action.payload;
    },
    resetNsfData: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNsfData.pending, (state) => {
        state.nsfData.status = "loading";
      })
      .addCase(fetchNsfData.fulfilled, (state, action) => {
        state.nsfData.data = action.payload;
        state.nsfData.status = "fulfilled";
      })
      .addCase(fetchNsfData.rejected, (state) => {
        state.nsfData.status = "failed";
      })
      .addCase(fetchNsfHistory.pending, (state) => {
        state.nsfHistory.status = "loading";
      })
      .addCase(fetchNsfHistory.fulfilled, (state, action) => {
        state.nsfHistory.data = action.payload;
        state.nsfHistory.status = "fulfilled";
      })
      .addCase(fetchNsfHistory.rejected, (state) => {
        state.nsfHistory.status = "failed";
      });
  },
});

export const { setNsfStatus, resetNsfData } = nsfSlice.actions;

export default nsfSlice.reducer;
